import { GROUPS } from "./shared";

/** Norwegian starters when API has no saved company payroll rates. Matches Economy::Settings::PAYROLL_DEFAULTS. */
export const PAYROLL_RATE_DEFAULTS = {
  holiday_percent: "12",
  pension_percent: "2",
  employer_tax_percent: "14.1",
  overtime_percent: "40",
  monthly_norm_hours: "162.5",
};

const BUDGET_PAYROLL_RATE_KEYS = ["holiday_percent", "pension_percent", "employer_tax_percent"];

export const blankPayrollRate = (value) => value === "" || value == null;

/** Copy confirmed company rates onto budget payroll inputs; skip null/empty so blank-budget starters remain. */
export function mergePayrollRatesFromSettings(payroll, settings) {
  const patch = Object.fromEntries(
    BUDGET_PAYROLL_RATE_KEYS
      .filter((key) => !blankPayrollRate(settings?.[key]))
      .map((key) => [key, settings[key]])
  );
  return { ...payroll, ...patch };
}

export function blankBudget(year, ownerId) {
  return { name: "", note: "", year, owner_id: ownerId || "", request_key: crypto.randomUUID(), inputs: {
    baseline: Object.fromEntries(["revenue", "payroll", ...GROUPS].map((key) => [key, "0"])),
    revenue: { method: "growth", growth_percent: "0", weights: Array(12).fill("1") },
    payroll: {
      growth_percent: "0",
      holiday_percent: PAYROLL_RATE_DEFAULTS.holiday_percent,
      pension_percent: PAYROLL_RATE_DEFAULTS.pension_percent,
      employer_tax_percent: PAYROLL_RATE_DEFAULTS.employer_tax_percent,
    },
    staff: [], cost_lines: GROUPS.map((group) => ({ group, method: "growth", value: "0" })), custom_lines: [],
  } };
}
export function staffFromSource(source, settings, targetYear = source.year + 1) {
  return source.employees.map((employee) => {
    const config = settings?.employees?.find((row) => String(row.id) === String(employee.id));
    const rate = config ? Number(config.rate) : 0;
    const reference = employee.salary_reference;
    const annual = !config ? reference?.yearly_salary || "" : config.method === "annual" ? rate : config.method === "monthly" ? rate * 12 : rate * Number(settings.monthly_norm_hours) * 12;
    const startYear = employee.employment_starts ? Number(employee.employment_starts.slice(0, 4)) : null;
    const endYear = employee.employment_ends ? Number(employee.employment_ends.slice(0, 4)) : null;
    const included = (employee.active || endYear != null) && (!startYear || startYear <= targetYear) && (!endYear || endYear >= targetYear);
    return { id: `employee-${employee.id}`, name: employee.name, included: included, annual_salary: String(annual), employment_percent: config?.employment_percent ?? reference?.position_percentage ?? "100", from_month: startYear === targetYear ? String(Number(employee.employment_starts.slice(5, 7))) : "1", to_month: endYear === targetYear ? String(Number(employee.employment_ends.slice(5, 7))) : "12" };
  });
}
export function copyBudget(budget) {
  const { name, note, year, owner_id, inputs } = budget;
  return { name, note, year, owner_id, inputs: JSON.parse(JSON.stringify(inputs)), request_key: crypto.randomUUID() };
}
